import {flow, getEnv, resolveIdentifier, types} from "mobx-state-tree";
import {ParameterSet} from "../../models/parameterSets/ParameterSetModel";
import {TagModel} from "../../models/tags/TagModel";

const ParameterSetStore = types.model('ParameterSetStore',{
    storeUuid: types.identifier,
    list: types.optional(types.array(ParameterSet), []),
    flatList: types.optional(types.array(types.frozen()), []), //for list component, //because list can't access nested MST tags model
    //isLoading..
}).volatile((self)=>({
  filterListOn:types.fn,
})).actions((self)=>({
  setFilterOn(groupUuid) {
    console.log("Inside ParameterSet Store", groupUuid)
    self.filterListOn = (item) => {   //function used to filter tag options by selected group
      return item?.owner?.groupUuid === groupUuid
    }
  },
    initWithData(items = []) {
        if (items) {
          self.list = items.map(item => {
            let nestedTags = [];
            if(item.tags && item.tags.length > 0){
              nestedTags = item.tags.map(t => resolveIdentifier(TagModel, self, t?.uuid))
            }
              return ParameterSet.create({
                uuid: item.uuid,
                name: item.name,
                label: item.name,
                _audit: item?._audit,
                createdAt: item?.createdAt,
                updatedAt: item?.updatedAt,
                tags: nestedTags
                //todo complete object
              })
          });
        } else {
          self.list = [];
        }
    },
    init: flow(function* f(params = {}) {
        console.log("load parameterSetStore from API");
        const resp = yield self.getParameterSets(params);
        if (!resp) {
            return;
        }
        self.setParameterSets(resp.results);
    }),
    getParameterSets: flow(function* getParameterSets(params = {}) {
             const res = yield getEnv(self).parameterSetManager.fetchAll(params);
             if(res !== null){
                 self.setParameterSets(res.results);
             }
             return res;
    }),
    setParameterSets(ParameterSets){
        const flatList = ParameterSets.map(item => {
          let nestedTags = []
          if(item.tags && item.tags.length > 0) {
            nestedTags = item.tags.map(t => resolveIdentifier(TagModel, self, t?.uuid))
          }
            return {
              uuid: item.uuid,
              name: item.name,
              label: item.name,
              _audit: item?._audit,
              owner: item.owner,
              createdAt: item?.createdAt,
              updatedAt: item?.updatedAt,
              isExclusivelyGroupOwned: item?.isExclusivelyGroupOwned,
              isEditable: item?.isEditable,
              tags: nestedTags,
            }
          }
        )
      self.flatList = flatList;
        console.log("self.flatList", self.flatList);
    },
    searchFor(txt){
        //TODO: search for groups with name like 'txt'
    }
})).views((self) => ({

  filteredList() {
    if(self.filterListOn) {
      // Filter by group if filterListOn is set
      return self.flatList.filter((item) => self.filterListOn(item))
    } else {
      // Return all items if no filter is set
      return self.flatList.slice();
    }
  }

}))



export default ParameterSetStore;
